import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import HomePage from "./screens/HomePage.js";
import Header from "./header/Header.js";
import About from "./screens/About.js";
import ProductsPage from "./screens/ProductsPage.js";
import CategoryPage from "./screens/CategoryPage.js";
import ProductGroupPage from "./screens/ProductGroupPage.js";
import Contact from "./screens/Contact.js";
import Footer from "./screens/Footer.js";
import NotFound from "./screens/NotFound.js";
import Seo from "./components/Seo.js";
import Analytics from "./components/Analytics.js";
import QuoteRequest from "./screens/QuoteRequest.js";
import { QuoteProvider } from "./context/QuoteContext.js";

function App() {
  return (
    <BrowserRouter>
      <QuoteProvider>
      <Seo />
      <Analytics />
      <Header />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="about" element={<About />} />
        <Route path="products" element={<ProductsPage />} />
        <Route path=":categorySlug" element={<CategoryPage />} />
        <Route path=":categorySlug/:productSlug" element={<ProductGroupPage />} />
        <Route path="/products/hingedduo" element={<Navigate to="/plastic-containers/hinged-containers-dual-tab-lock" replace />} />
        <Route path="/products/centerslide" element={<Navigate to="/plastic-containers/hinged-containers-center-slide" replace />} />
        <Route path="/products/deli" element={<Navigate to="/plastic-containers/deli-containers" replace />} />
        <Route path="/products/portion" element={<Navigate to="/plastic-containers/portion-cups-and-lids" replace />} />
        <Route path="/products/round" element={<Navigate to="/plastic-containers/round-sealed-containers" replace />} />
        <Route path="/products/noodle" element={<Navigate to="/plastic-containers/noodle-bowls" replace />} />
        <Route path="/products/rectangular" element={<Navigate to="/plastic-containers/rectangular-sealed-containers" replace />} />
        <Route path="/products/compartment" element={<Navigate to="/plastic-containers/compartmental-sealed-containers" replace />} />
        <Route path="/products/coldcup" element={<Navigate to="/cups/pet-cold-cups" replace />} />
        <Route path="/products/hotcup" element={<Navigate to="/cups/paper-hot-cups" replace />} />
        <Route path="/bags/tshirt" element={<Navigate to="/bags/plastic-t-shirt-bags" replace />} />
        <Route path="/bags/paperbag" element={<Navigate to="/bags/brown-paper-bags" replace />} />
        <Route path="/bags/trashbag" element={<Navigate to="/bags/trash-bags" replace />} />
        <Route path="/misc/cutlery" element={<Navigate to="/misc/medium-duty-cutlery" replace />} />
        <Route path="/misc/napkin" element={<Navigate to="/misc/napkins" replace />} />
        <Route path="/misc/glove" element={<Navigate to="/misc/nitrile-gloves" replace />} />
        <Route path="/misc/foil" element={<Navigate to="/misc/aluminum-foil" replace />} />
        <Route path="contact" element={<Contact />} />
        <Route path="request-quote" element={<QuoteRequest />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
      <Footer />
      </QuoteProvider>
    </BrowserRouter>
  );
}

export default App;
